
import Vue from 'vue';
import Component from 'vue-class-component';
import NodeFormMixin from '../forms/NodeFormMixin';

@Component({
  name: 'SmsSummary',
})
export default class SmsSummary extends NodeFormMixin {}
